var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n'], ['\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 0 3rem 0rem 3rem;\n  max-width: 800px;\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n  h4 {\n    margin-top: 0px;\n  }\n'], ['\n  padding: 0 3rem 0rem 3rem;\n  max-width: 800px;\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n  h4 {\n    margin-top: 0px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  min-height: 50vh;\n  text-align: center;\n  overflow: hidden;\n'], ['\n  width: 100%;\n  min-height: 50vh;\n  text-align: center;\n  overflow: hidden;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  /* width: 100%;\n  height: 100%; */\n  object-fit: cover;\n transform: translateX(-25%);\n'], ['\n  /* width: 100%;\n  height: 100%; */\n  object-fit: cover;\n transform: translateX(-25%);\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-flexa';
import Button from '../../StyledComponents/Button';
var Container = styled.div(_templateObject);
var TextContainer = styled.div(_templateObject2);
var ImageContainer = styled.div(_templateObject3);
var Img = styled.img(_templateObject4);

var Text16 = function (_Component) {
  _inherits(Text16, _Component);

  function Text16() {
    _classCallCheck(this, Text16);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Text16.prototype.render = function render() {
    return React.createElement(Container, null, React.createElement(Row, {
      justifyContent: 'center'
    }, React.createElement(Col, {
      xs: 12,
      sm: 12,
      md: 4,
      alignSelf: 'center'
    }, React.createElement(ImageContainer, null, React.createElement(Img, {
      src: 'https://www.fillmurray.com/800/800'
    }))), React.createElement(Col, {
      xs: 12,
      sm: 12,
      md: 8
    }, React.createElement(TextContainer, null, React.createElement('h4', null, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin quis ante nec eros aliquam dictum.'), React.createElement(Button, {
      size: 'medium',
      colour: 'primary',
      onClick: function onClick() {
        return alert('Button clicked!');
      }
    }, 'Click Me')))));
  };

  return Text16;
}(Component);

export default Text16;